import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'sonner';
import { ProtectedRoute, PublicRoute } from './components/ProtectedRoute';

// Pages
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { GenererQuestionnairePage } from './pages/GenererQuestionnairePage';
import { LancerTestPage } from './pages/LancerTestPage';
import { RapportTestPage } from './pages/RapportTestPage';
import { QuestionnairesPage } from './pages/QuestionnairesPage';
import { QuestionsPage } from './pages/QuestionsPage';
import { HistoriquePage } from './pages/HistoriquePage';
import { ComparerCandidatsPage } from './pages/ComparerCandidatsPage';
import { AdminPage } from './pages/AdminPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { CandidatsPage } from './pages/CandidatsPage';
import { ParametresPage } from './pages/ParametresPage';
import { LancerTestExternePage } from './pages/LancerTestExternePage';

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } />
          <Route path="/register" element={
            <PublicRoute>
              <RegisterPage />
            </PublicRoute>
          } />
          <Route path="/forgot-password" element={
            <PublicRoute>
              <ForgotPasswordPage />
            </PublicRoute>
          } />

          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/questionnaires" element={
            <ProtectedRoute>
              <QuestionnairesPage />
            </ProtectedRoute>
          } />
          <Route path="/questions" element={
            <ProtectedRoute>
              <QuestionsPage />
            </ProtectedRoute>
          } />
          <Route path="/generer" element={
            <ProtectedRoute>
              <GenererQuestionnairePage />
            </ProtectedRoute>
          } />
          <Route path="/historique" element={
            <ProtectedRoute>
              <HistoriquePage />
            </ProtectedRoute>
          } />
          <Route path="/candidats" element={
            <ProtectedRoute>
              <CandidatsPage />
            </ProtectedRoute>
          } />
          <Route path="/lancer-test/:questionnaireId" element={
            <ProtectedRoute>
              <LancerTestPage />
            </ProtectedRoute>
          } />
          <Route path="/rapport/:testId" element={
            <ProtectedRoute>
              <RapportTestPage />
            </ProtectedRoute>
          } />
          <Route path="/comparer" element={
            <ProtectedRoute>
              <ComparerCandidatsPage />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          } />
          <Route path="/changer-mot-de-passe" element={
            <ProtectedRoute>
              <ChangePasswordPage />
            </ProtectedRoute>
          } />
          <Route path="/parametres" element={
            <ProtectedRoute>
              <ParametresPage />
            </ProtectedRoute>
          } />
          <Route path="/integrations-ats" element={<Navigate to="/admin" replace />} />
          <Route path="/lancer-test-externe" element={
            <ProtectedRoute>
              <LancerTestExternePage />
            </ProtectedRoute>
          } />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
